import {Button, Card, Col, Form, Input, message, Row, Select, Spin} from "antd";
import {useEffect, useState} from "react";
import accountService from "../../service/accountService";
import ErrorHandler from "../../util/ErrorHandler";
import customerService from "../../service/customerService";
import {getUserInfo} from "../../security/KeyclockConfig";
import {BankDetailDto} from "../../dto/BankDetailDto";
import {IndividualAccountWrapperDto} from "../../dto/IndividualAccountWrapperDto";
import {new_acc_img} from '../../../AppImageConst';
import {UserAddOutlined} from "@ant-design/icons";
import './style.scss'
import Validation from "../../util/Validation";


const IndividualAccountComp = () => {
    const [bankAccountList, setBankAccountList] = useState<BankDetailDto[]>([]);
    const [customerId, setCustomerId] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [form] = Form.useForm();
    useEffect(() => {
        getLoggedUser();
    }, [])

    const getLoggedUser = () => {
        getUserInfo().then((res: any) => {
            getCustByUserName(res.preferred_username)
        });
    }

    const getCustByUserName = (userName: string) => {
        customerService.getCustomerByUserName(userName).then((res: any) => {
            if (res.data.results.customerMstDto != null) {
                if (res.data.results.customerMstDto?.bankDetailList.length > 0) {
                    console.log(res.data.results.customerMstDto)
                    setBankAccountList(res.data.results.customerMstDto.bankDetailList)
                    setCustomerId(res.data.results.customerMstDto.id)
                }
            }

        }).catch((reason) => {
            ErrorHandler.handleError(reason);
        });
    }

    const saveNewAccountDetail = (values:any) => {
        setIsLoading(true)
        const individualAccWrapperDto:IndividualAccountWrapperDto={
            customerId:customerId,
            username:"",
            nickname:values.nickname,
            linkedAccount:values.linkedAccount
        }
        accountService.createIndividualAccountInExistingFlow(individualAccWrapperDto).then((res: any) => {
            setIsLoading(false)
            message.success("New account detail submitted successfully").then(
                form.resetFields(["nickname", "linkedAccount"])
            )
        }).catch((reason) => {
            setIsLoading(false)
            ErrorHandler.handleError(reason);
        });
    }
    return (
        <Spin spinning={isLoading}>
            <Row gutter={[40, 0]} className='right-side-container-margin'>
                <Col lg={10} md={10} sm={0}
                     className={'left-side-main-container left-side-main-container-inside-dashboard'}>
                    <Row>
                        <Col span={24}>
                            <div className="clip-path-img">
                                <div className='clip-path-img-container'>
                                    <img src={new_acc_img} alt="logo"/>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>
                <Col lg={14} md={14} sm={24} className='right-side-main-container-inside-dashboard layout-bottom-space dashboard-right-side-contaner-scroll'>
                    <Form style={{width: '100%'}}
                        className='form-input align-div-center'
                        layout={"vertical"}
                        onFinish={saveNewAccountDetail}
                        form={form}
                    >
                        <div className='account_type_container second-applicant-details width-100' style={{paddingTop:16}}>
                           <div>
                               <Row gutter={[32, 0]}>

                                   <Col xs={24} sm={24} md={24} lg={24} xl={24} className='page-header-main-title-col'>
                                       <h2 className='page-header-main-title'>
                                           <div className='header_icon header-icon-center'>
                                               <UserAddOutlined />
                                           </div>
                                           New Account Details
                                       </h2>
                                   </Col>
                               </Row>
                               <Card className={'template_card'}>
                                   <Row gutter={[32, 0]}>
                                       <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                           <Form.Item
                                               label="Name of the new Portfolio"
                                               name={"nickname"}
                                               onKeyPress={Validation.alphanumericDashAndDotCharacters}
                                               rules={[
                                                   {required: true, message: 'Please enter portfolio name'},
                                                   {whitespace: true, message: 'Cannot contain whitespaces'},
                                                   {min: 4, message: 'Minimum of 4 characters are required'},
                                                   {max: 50, message: 'The maximum length is 50 characters'}]}>
                                               <Input size={'large'} placeholder={"Enter portfolio name"}/>
                                           </Form.Item>
                                       </Col>
                                       <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                           <Form.Item
                                               label="Select the bank account you wish to add to the portfolio"
                                               name={"linkedAccount"}
                                               rules={
                                                   [{required: true, message: 'Please select bank account'}]}>
                                               <Select placeholder={"Select bank account"} size={'large'}
                                                   // onChange={onchangeIsExistingCustomer}
                                                       getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                                                       style={{width: '100%'}}

                                               >
                                                   {
                                                       bankAccountList.map((data: BankDetailDto) => {

                                                           return <Select.Option key={data.id}
                                                                                 value={data.id}>{data.accountNo + " - " + data.bankName + "(" + data.branchName + ")"}</Select.Option>
                                                       })
                                                   }

                                               </Select>
                                           </Form.Item>
                                       </Col>
                                   </Row>
                               </Card>

                           </div>

                        <div className='dashboard-inside-button-row'>
                            <Row gutter={[32, 0]}>

                                <Col sm={24} lg={{span: 8, offset: 16}} className='continue-btn-col text-right'>
                                    <Form.Item className='form-item-btn'>
                                        <Button  htmlType="submit" type="primary"
                                                className='custom-btn-primary ant-btn margin_top_20'>
                                            Submit
                                        </Button>
                                    </Form.Item>
                                </Col>

                            </Row>
                        </div>
                    </div>
                    </Form>
                </Col>
            </Row>
        </Spin>
    )

}
export default IndividualAccountComp;

